import ConsultingCaseListResourceListResultModel from '../../generated/types/model/resource/ConsultingCaseListResourceListResultModel';

export default class ConsultingCaseListResourceListResultViewModel extends ConsultingCaseListResourceListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
